var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found"},[_c('v-header',{attrs:{"title":_vm.$t('page_not_found')}}),_c('v-error',{attrs:{"title":_vm.$t('page_not_found'),"body":_vm.$t('page_not_found_body'),"icon":"not_interested"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }